// noinspection ES6UnusedImports
import '../sass/main.scss'; //do not remove!

if (window.sfEnv && window.sfEnv.isDesignMode) {
    import('./backend-tweaks')
}